import React from 'react';
import { ReactComponent as ReactLogo } from '../../../../src/assets/svg/options-icon.svg';

function OptionsIcon(props: {
    className?: string;
    height?: string | number;
    width?: string | number;
    fill?: string;
}) {
    return (
        <ReactLogo
            className={props.className}
            width='15px'
            height='10px'
            fill={props.fill}
        />
    );
}

export default OptionsIcon;
